/*
  Auto-Add fürs Warenkorb: liest Regeln aus #bogo-rules-data (sections/bogo-auto-add-rules.liquid)
  und hält Geschenk-Produkte im Warenkorb synchron zur Trigger-Menge, ohne sichtbares Widget.
  Die eigentliche Preis-Nullstellung des Geschenks übernimmt eine separat konfigurierte
  Rabattlogik (App/Automatic Discount) -- dieses Skript kümmert sich nur ums Line-Item selbst.
*/
(function () {
  var nativeFetch = window.fetch.bind(window);
  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var state = { evaluating: false, pending: false, lastSignature: null };
  var cachedConfig = null;

  function getConfig() {
    if (cachedConfig) return cachedConfig;
    var el = document.getElementById('bogo-rules-data');
    if (!el) return null;
    try {
      cachedConfig = JSON.parse(el.textContent);
    } catch (e) {
      console.error('[bogo-auto-add] invalid config JSON', e);
      cachedConfig = { enabled: false, rules: [] };
    }
    return cachedConfig;
  }

  function setCookie(name, value, days) {
    var maxAge = Math.max(1, Math.round(days * 24 * 60 * 60));
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
  }

  function getCookie(name) {
    var escaped = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
    var match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function applyLinkCookies(rules) {
    var params = new URLSearchParams(window.location.search);
    rules.forEach(function (rule) {
      if (!rule.requires_link || !rule.link_param) return;
      var idx = rule.link_param.indexOf('=');
      if (idx === -1) return;
      var key = rule.link_param.slice(0, idx);
      var value = rule.link_param.slice(idx + 1);
      if (params.get(key) === value) {
        setCookie('bogo_link_' + rule.id, '1', rule.cookie_days || 1);
      }
    });
  }

  function sumQty(items, predicate) {
    return items.filter(predicate).reduce(function (sum, item) { return sum + item.quantity; }, 0);
  }

  function signatureOf(cart) {
    return (cart.items || [])
      .map(function (i) { return i.handle + ':' + i.quantity + ':' + ((i.properties && i.properties._bogo_rule) || ''); })
      .sort()
      .join('|');
  }

  async function nativeFetchJson(path, method, body) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var opts = { method: method, headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    if (body) opts.body = JSON.stringify(body);
    var res = await nativeFetch(root + path, opts);
    return res.json();
  }

  function collectChanges(rules, cart) {
    var changes = [];
    rules.forEach(function (rule) {
      if (rule.requires_link && !getCookie('bogo_link_' + rule.id)) return;

      var triggerQty = sumQty(cart.items, function (item) {
        return item.handle === rule.trigger_handle && !(item.properties && item.properties._bogo_rule);
      });

      var targetGiftQty = Math.floor(triggerQty / rule.trigger_qty) * rule.gift_qty;
      if (rule.max_gift_qty != null && targetGiftQty > rule.max_gift_qty) {
        targetGiftQty = rule.max_gift_qty;
      }

      var giftLine = cart.items.find(function (item) {
        return item.handle === rule.gift_handle && item.properties && item.properties._bogo_rule === rule.id;
      });
      var existingGiftQty = giftLine ? giftLine.quantity : 0;

      if (targetGiftQty !== existingGiftQty) {
        changes.push({ rule: rule, targetGiftQty: targetGiftQty, existingLineKey: giftLine ? giftLine.key : null });
      }
    });
    return changes;
  }

  async function applyChanges(changes) {
    var bundleSections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: bundleSections }
    }));
    var sectionsParam = bundleSections.join(',');
    var lastSectionsResponse = null;

    for (var i = 0; i < changes.length; i++) {
      var change = changes[i];
      var response;
      if (change.existingLineKey == null && change.targetGiftQty > 0) {
        response = await nativeFetchJson('cart/add.js', 'POST', {
          items: [{
            id: change.rule.gift_variant_id,
            quantity: change.targetGiftQty,
            properties: { _bogo_rule: change.rule.id, _bogo_auto: 'true' }
          }],
          sections: sectionsParam,
          sections_url: window.location.pathname
        });
      } else if (change.existingLineKey != null) {
        response = await nativeFetchJson('cart/change.js', 'POST', {
          id: change.existingLineKey,
          quantity: change.targetGiftQty,
          sections: sectionsParam,
          sections_url: window.location.pathname
        });
      }
      if (response && response.sections) lastSectionsResponse = response.sections;
    }

    var cart = await nativeFetchJson('cart.js', 'GET');
    if (lastSectionsResponse) cart.sections = lastSectionsResponse;

    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'variant:add', cart: cart }
    }));
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    // Die sichtbare Warenkorb-Oberfläche kommt auf dieser Seite von der upcart-cart-drawer
    // App (eigenes #upCart-Overlay), nicht vom Theme-eigenen (unsichtbaren) <cart-drawer>.
    // Ohne diesen Aufruf bleibt upCart auf dem Stand vor unserer Änderung stehen.
    if (typeof window.upcartRefreshCart === 'function') {
      window.upcartRefreshCart();
    }

    return cart;
  }

  async function evaluate(cartHint) {
    var cfg = getConfig();
    if (!cfg || !cfg.enabled || !cfg.rules.length) return;

    var cart = cartHint || await nativeFetchJson('cart.js', 'GET');
    var sig = signatureOf(cart);
    if (sig === state.lastSignature) return;

    var changes = collectChanges(cfg.rules, cart);
    if (!changes.length) {
      state.lastSignature = sig;
      return;
    }

    var updatedCart = await applyChanges(changes);
    state.lastSignature = signatureOf(updatedCart);
  }

  async function queueEvaluate(cartHint) {
    if (state.evaluating) {
      state.pending = true;
      return;
    }
    state.evaluating = true;
    try {
      await evaluate(cartHint);
    } catch (e) {
      console.error('[bogo-auto-add]', e);
    } finally {
      state.evaluating = false;
      if (state.pending) {
        state.pending = false;
        queueEvaluate();
      }
    }
  }

  function patchFetch() {
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var shouldWatch = method === 'POST' && CART_MUTATION_RE.test(url);
      var result = originalFetch.apply(this, arguments);
      if (shouldWatch) {
        result.then(function () { queueEvaluate(); }).catch(function () {});
      }
      return result;
    };
  }

  function init() {
    var cfg = getConfig();
    if (!cfg) return;

    applyLinkCookies(cfg.rules);
    document.documentElement.addEventListener('cart:change', function (e) {
      queueEvaluate(e.detail && e.detail.cart);
    });
    patchFetch();
    queueEvaluate();

    // Garantiert frischer Drawer-Inhalt im Moment des Öffnens, unabhängig davon, ob
    // andere Skripte (z.B. Drittanbieter-Cart-Apps) unser Update zwischenzeitlich
    // mit einem veralteten Stand überschrieben haben.
    document.addEventListener('click', function (e) {
      if (e.target.closest('[aria-controls="cart-drawer"]') || e.target.closest('#upCartStickyButton')) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (typeof window.upcartRefreshCart === 'function') {
          window.upcartRefreshCart();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
